export default __webpack_public_path__ + "static/media/vid_measure_350.a62583fe.jpg";